import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import { moduli } from '../../config';
import { ProizvodiAkcijaService } from './proizvodi-akcija.service';

@Component({
  selector: 'app-proizvodi-akcija',
  templateUrl: './proizvodi-akcija.component.html',
  styleUrls: ['./proizvodi-akcija.component.scss'],
  providers: [ProizvodiAkcijaService],
})
export class ProizvodiAkcijaComponent implements OnInit {
  poruka: string;
  akcijskiProizvodi: any;
  dohvacanjeAkcija: boolean = true;
  akcijaPopupVisible: boolean = false;
  akcijaFormaPoruka: string;
  sviProizvodi = [];
  artiklId: number = null;
  odabraniProizvod: number;
  datumOd = null; //moment();
  datumDo = null; //moment();
  datumOd_filter = moment().startOf('month');
  datumDo_filter = moment();
  datumOdFormatiran: string = this.datumOd_filter.format('YYYY-MM-DD');
  datumDoFormatiran: string = this.datumDo_filter.format('YYYY-MM-DD');
  partneri = [];
  poslovnice = [];
  partnerId: number = null;
  odabraniPartner: number = null;
  odabranaPoslovnica: number;
  kolicina: number;
  obrisiAkcijuPopupVisible: boolean = false;
  idCjenikZaglavlje: number;
  idCjenikStavka: number;

  idkorisnik: any;
  access_token: any;
  idfirma: any;

  tjedanPocetak: any;
  tjedanZavrsetak: any;
  tjedanPocetak_filter: any;
  tjedanZavrsetak_filter: any;
  godina = moment().format('YYYY');
  sviTjedni: any = [];

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  constructor(private service: ProizvodiAkcijaService, private router: Router) {
    if (parseInt(localStorage.getItem('firma')) == 3) {
      this.router.navigate(['/dostavnica-hlad']);
    }

    this.idkorisnik = localStorage.getItem('idsecuser');
    this.access_token = sessionStorage.getItem('token');
    this.idfirma = localStorage.getItem('firma');

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().proizvodiNaAkciji;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  ngOnInit() {
    this.dohvatiProizvodeNaAkciji();
    this.dohvatiSveProizvode();
    this.dohvatiPartnere();
    //this.dohvatiPoslovnice();
    this.dohvatiTjedne();
  }

  // DOHVAĆANJE SVIH PROIZVODA NA AKCIJI
  dohvatiProizvodeNaAkciji() {
    this.poruka = 'Učitavanje...';
    this.dohvacanjeAkcija = true;
    this.akcijskiProizvodi = [];
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token,
      datumOd: this.datumOdFormatiran,
      datumDo: this.datumDoFormatiran,
      //week_id_pocetak_akcije: this.tjedanPocetak_filter,
      //week_id_kraj_akcije: this.tjedanZavrsetak_filter,
      idpartner: this.partnerId,
      idartikl: this.artiklId
    }
    //console.log(podaciZaSlanje);
    this.service.dohvatiProizvodeNaAkciji(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      this.dohvacanjeAkcija = false;
      this.akcijskiProizvodi = [];
      if (res.success === true) {
        if (res.data.length == 0) {
          this.poruka = 'Nema aktivnih akcija!';
        } else {
          this.poruka = 'Učitavanje...';
        }
        for (let akcija of res.data) {
          this.akcijskiProizvodi.push({
            id: akcija.cj_idi,
            idProizvod: akcija.artikl_ar_id,
            sifraProizvoda: akcija.ar_sifra,
            nazivProizvoda: akcija.ar_naziv,
            pocetakAkcije: akcija.cj_odkada,
            krajAkcije: akcija.cj_dokada,
            period:
              moment(akcija.cj_odkada).format('DD.MM.YYYY.') +
              ' - ' +
              moment(akcija.cj_dokada).format('DD.MM.YYYY.'),
            partnerId: akcija.partner_pa_id,
            partner: akcija.pa_naziv,
            poslovnica: akcija.pp_naziv,
            poslovnicaId: akcija.poslovnicapartnera_pp_id,
            kolicina: akcija.cs_kolicina,
            idCjenikZaglavlje: akcija.cjenikzaglavlje_cj_idi,
            idCjenikStavka: akcija.cs_id,
            week_id_kraj_akcije: akcija.week_id_kraj_akcije,
            week_id_pocetak_akcije: akcija.week_id_pocetak_akcije,
            week_in_year_kraj_akcije: akcija.week_in_year_kraj_akcije,
            week_in_year_pocetak_akcije: akcija.week_in_year_pocetak_akcije
          });
        }
        //console.log(this.akcijskiProizvodi);
      } else {
        this.poruka = 'Greška konekcije ili baze!';
      }
    });
  }

  // ========== DOHVAĆANJE SVIH PROIZVODA ==========
  dohvatiSveProizvode() {
    this.service.dohvatiSveProizvode({}).subscribe((res) => {
      //console.log(res);
      this.sviProizvodi = [];
      for (let data of res.data) {
        this.sviProizvodi.push({
          id: data.ar_id,
          sifra: data.ar_sifra,
          naziv: data.ar_naziv,
          sifra_i_naziv: data.ar_sifra + ' ' + data.ar_naziv
        });
      }
      //console.log(this.sviProizvodi);
    });
  }

  // ========== DODAVANJE AKCIJE ==========
  dodajAkcijuPopup() {
    this.akcijaPopupVisible = true;
    this.akcijaFormaPoruka = 'Dodavanje!';
    this.odabraniProizvod = null;
    this.tjedanPocetak = null;
    this.tjedanZavrsetak = null;
    this.datumOd = null; //moment();
    this.datumDo = null; //moment();
    this.odabraniPartner = null;
    this.odabranaPoslovnica = null;
    this.kolicina = null;
  }

  dodajAkciju() {
    let data = {
      idartikl: this.odabraniProizvod,
      kolicina: this.kolicina,
      odkada: moment(this.datumOd).format('YYYY-MM-DD'),
      dokada: moment(this.datumDo).format('YYYY-MM-DD'),
      idpartner: this.odabraniPartner,
      idposlovnica: this.odabranaPoslovnica,
    };
    //console.log(data);
    this.service.dodajNovuAkciju(data).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        this.dohvatiProizvodeNaAkciji();
        notify('Uspješno dodavanje nove akcije.', 'success', 3000);
        this.akcijaPopupVisible = false;
      } else {
        notify('Došlo je do pogreške! Akcija nije dodana!', 'error', 3000);
      }
    });
  }

  // ========== UREĐIVANJE AKCIJE ==========
  urediAkcijuPopup(data) {
    //console.log(data);
    this.akcijaPopupVisible = true;
    this.akcijaFormaPoruka = 'Uređivanje!';
    this.odabraniProizvod = data.data.idProizvod;
    this.datumOd = moment(data.data.pocetakAkcije);
    this.datumDo = moment(data.data.krajAkcije);
    this.odabraniPartner = data.data.partnerId;
    this.odabranaPoslovnica = data.data.poslovnicaId;
    this.kolicina = data.data.kolicina;
    this.idCjenikZaglavlje = data.data.idCjenikZaglavlje;
    this.idCjenikStavka = data.data.idCjenikStavka;
    this.tjedanPocetak = data.data.week_id_pocetak_akcije;
    this.tjedanZavrsetak = data.data.week_id_kraj_akcije;
  }

  urediAkciju() {
    let data = {
      idcjenikzaglavlje: this.idCjenikZaglavlje,
      idcjenikstavka: this.idCjenikStavka,
      idartikl: this.odabraniProizvod,
      kolicina: this.kolicina,
      odkada: moment(this.datumOd).format('YYYY-MM-DD'),
      dokada: moment(this.datumDo).format('YYYY-MM-DD'),
      idpartner: this.odabraniPartner,
      idposlovnica: this.odabranaPoslovnica,
    };
    //console.log(data);
    this.service.urediAkciju(data).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        this.dohvatiProizvodeNaAkciji();
        notify('Uspješno uređivanje akcije.', 'success', 3000);
        this.akcijaPopupVisible = false;
      } else {
        notify('Došlo je do pogreške!', 'error', 3000);
      }
    });
  }

  // ========== BRISANJE AKCIJE ==========
  obrisiAkcijuPopup(data) {
    //console.log(data);
    this.obrisiAkcijuPopupVisible = true;
    this.idCjenikZaglavlje = data.data.idCjenikZaglavlje;
    this.idCjenikStavka = data.data.idCjenikStavka;
  }

  obrisiAkciju() {
    let data = {
      idcjenikzaglavlje: this.idCjenikZaglavlje,
      idcjenikstavka: this.idCjenikStavka,
    };
    //console.log(data);
    this.service.obrisiAkciju(data).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        this.dohvatiProizvodeNaAkciji();
        notify('Uspješno brisanje akcije.', 'success', 3000);
        this.obrisiAkcijuPopupVisible = false;
      } else {
        notify('Došlo je do pogreške!', 'error', 3000);
      }
    });
  }

  // ========== PARTNERI ==========
  dohvatiPartnere() {
    this.service.dohvatiPartnere({}).subscribe((res) => {
      //console.log(res);
      this.partneri = [];
      if (res.success === true) {
        for (let partner of res.data) {
          this.partneri.push({
            id: partner.pa_id,
            sifra: partner.pa_sifra,
            naziv: partner.pa_naziv,
          });
        }
        //console.log(this.partneri);
      }
    });
  }

  // ========== POSLOVNICE PARTNERA ==========
  dohvatiPoslovnice() {
    this.service.dohvatiPoslovnice({idpartner: this.odabraniPartner, idfirma: this.idfirma}).subscribe((res) => {
      //console.log(res);
      this.poslovnice = [];
      if (res.success === true) {
        for (let poslovnica of res.data) {
          this.poslovnice.push({
            id: poslovnica.pp_id,
            naziv: poslovnica.pp_naziv,
          });
        }
        //console.log(this.poslovnice);
      }
    });
  }

  dohvatiTjedne(){
    this.service.dohvatiTjedne_u_godini({godina: this.godina}).subscribe(res=>{
      //console.log(res);
      if (res.success == true) {
        this.sviTjedni = res.data; 
        //console.log(this.sviTjedni)
      }
    });
  }

  // ========== ON CHANGE VALUE ==========
  odabranTjedanOd(e){
    //console.log(e);
    this.tjedanPocetak_filter = e.value;
    this.dohvatiDatumOd().then((dat_Od: any) =>{
      //console.log('res dat_Od: ', dat_Od);
      if (dat_Od) {
        this.dohvatiProizvodeNaAkciji();
      }
    });
  }
  dohvatiDatumOd() {
    return new Promise((resolve) => {
      let podaciZaSlanje = {
        week_id: this.tjedanPocetak_filter
      }
      this.service.dohvatiDatume_za_tjedan(podaciZaSlanje).subscribe(res=>{
        //console.log(res);
        if (res.success == true) {
          this.datumOd_filter = res.data[0].datumod;
          this.datumOdFormatiran = moment(res.data[0].datumod).format('YYYY-MM-DD');
          resolve(1);
        }else{
          resolve(0);
        }
      });
    });
  }
  odabranTjedanDo(e) {
    //console.log(e);
    this.tjedanZavrsetak_filter = e.value;
    this.dohvatiDatumDo().then((dat_Do: any) =>{
      //console.log('res dat_Do: ', dat_Do);
      if (dat_Do) {
        this.dohvatiProizvodeNaAkciji();
      }
    });
  }
  dohvatiDatumDo() {
    return new Promise((resolve) => {
      let podaciZaSlanje = {
        week_id: this.tjedanZavrsetak_filter
      }
      this.service.dohvatiDatume_za_tjedan(podaciZaSlanje).subscribe(res=>{
        //console.log(res);
        if (res.success == true) {
          this.datumDo_filter = res.data[0].datumdo;
          this.datumDoFormatiran = moment(res.data[0].datumdo).format('YYYY-MM-DD');
          resolve(1);
        }else{
          resolve(0);
        }
      });
    });
  }
  odabranDatumOd(e) {
    //console.log(e);
    this.datumOdFormatiran = moment(e.value).format('YYYY-MM-DD');
    this.dohvatiTjedanOd().then((tje_Od: any) =>{
      //console.log('res tje_Od: ', tje_Od);
      if (tje_Od) {
        this.dohvatiProizvodeNaAkciji();
      }
    });
  }
  dohvatiTjedanOd(){
    return new Promise((resolve) => {
      let podaciZaSlanje = {
        datum: this.datumOdFormatiran
      }
      this.service.dohvatiTjedan_za_datum(podaciZaSlanje).subscribe(res=>{
        //console.log(res);
        if (res.success == true) {
          this.tjedanPocetak_filter = res.data[0].week_id;
          resolve(1);
        }else{
          resolve(0);
        }
      });
    });
  }
  odabranDatumDo(e) {
    //console.log(e);
    this.datumDoFormatiran = moment(e.value).format('YYYY-MM-DD');
    this.dohvatiTjedanDo().then((tje_Do: any) =>{
      //console.log('res tje_Do: ', tje_Do);
      if (tje_Do) {
        this.dohvatiProizvodeNaAkciji();
      }
    });
  }
  dohvatiTjedanDo(){
    return new Promise((resolve) => {
      let podaciZaSlanje = {
        datum: this.datumDoFormatiran
      }
      this.service.dohvatiTjedan_za_datum(podaciZaSlanje).subscribe(res=>{
        //console.log(res);
        if (res.success == true) {
          this.tjedanZavrsetak_filter = res.data[0].week_id;
          resolve(1);
        }else{
          resolve(0);
        }
      });
    });
  }
  odabranPartner(e) {
    this.partnerId = e.value;
    this.dohvatiProizvodeNaAkciji();
  }
  odabranProizvod(e) {
    this.artiklId = e.value;
    this.dohvatiProizvodeNaAkciji();
  }
  onChangeProizvod(e) {
    this.odabraniProizvod = e.value;
  }
  odabranTjedanPocetka(e){
    //console.log(e);
    this.tjedanPocetak = e.value;

    if (e.value) {
      let podaciZaSlanje = {
        week_id: e.value
      }
      this.service.dohvatiDatume_za_tjedan(podaciZaSlanje).subscribe(res=>{
        //console.log(res);
        if (res.success == true) {
          this.datumOd = res.data[0].datumod;
          //console.log('tjedan pocetak datumod: ', moment(res.data[0].datumod).format('YYYY-MM-DD'));
          //console.log('tjedan pocetak datumdo: ', moment(res.data[0].datumdo).format('YYYY-MM-DD'));
        }
      });
    }
  }
  odabranTjedanZavrsetka(e){
    //console.log(e);
    this.tjedanZavrsetak = e.value;

    if (e.value) {
      let podaciZaSlanje = {
        week_id: e.value
      }
      this.service.dohvatiDatume_za_tjedan(podaciZaSlanje).subscribe(res=>{
        //console.log(res);
        if (res.success == true) {
          this.datumDo = res.data[0].datumdo;
          //console.log('tjedan zavrsetak datumod: ', moment(res.data[0].datumod).format('YYYY-MM-DD'));
          //console.log('tjedan zavrsetak datumdo: ', moment(res.data[0].datumdo).format('YYYY-MM-DD'));
        }
      });
    }
  }
  odabranDatumPocetka(e) {
    if (e.value) {
      let podaciZaSlanje = {
        datum: moment(e.value).format('YYYY-MM-DD')
      }
      this.service.dohvatiTjedan_za_datum(podaciZaSlanje).subscribe(res=>{
        //console.log(res);
        if (res.success == true) {
          this.tjedanPocetak = res.data[0].week_id;
        }
      });
    }
  }
  odabranDatumZavrsetka(e) {
    if (e.value) {
      let podaciZaSlanje = {
        datum: moment(e.value).format('YYYY-MM-DD')
      }
      this.service.dohvatiTjedan_za_datum(podaciZaSlanje).subscribe(res=>{
        //console.log(res);
        if (res.success == true) {
          this.tjedanZavrsetak = res.data[0].week_id;
        }
      });
    }
  }
  onValueChangedDatumOd(e) {
    this.datumOd = e.value;
  }
  onValueChangedDatumDo(e) {
    this.datumDo = e.value;
  }
  onChangePartner(e) {
    this.odabraniPartner = e.value;
    this.dohvatiPoslovnice();
  }
  onChangePoslovnica(e) {
    this.odabranaPoslovnica = e.value;
  }
  onChangeKolicina(e) {
    this.kolicina = e.value;
  }

  // ========== TABLE OPTIONS ==========
  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift(
      {
        location: 'before',
        template: 'naslovTablice',
      }
      // {
      //   location: 'after',
      //   template: 'odabirDatuma',
      // },
    );
  }
}
